import {fsa, fsaError, fsaPayload, fsaPayloadByKeys} from '../helpers'

export const GET_SHOWROOM_APPOINTMENT_SCHEDULE = 'get showroom appointment schedule'
export const getShowroomAppointmentSchedule = fsaPayloadByKeys(GET_SHOWROOM_APPOINTMENT_SCHEDULE, [
  'locationId',
  'serviceId',
])

export const GET_SHOWROOM_APPOINTMENT_SCHEDULE_PENDING = 'get showroom appointment schedule pending'
export const getShowroomAppointmentSchedulePending = fsa(GET_SHOWROOM_APPOINTMENT_SCHEDULE_PENDING)

export const GET_SHOWROOM_APPOINTMENT_SCHEDULE_SUCCESS = 'get showroom appointment schedule success'
export const getShowroomAppointmentScheduleSuccess = fsaPayload(
  GET_SHOWROOM_APPOINTMENT_SCHEDULE_SUCCESS,
)

export const GET_SHOWROOM_APPOINTMENT_SCHEDULE_FAILURE = 'get showroom appointment schedule failure'
export const getShowroomAppointmentScheduleFailure = fsaError(
  GET_SHOWROOM_APPOINTMENT_SCHEDULE_FAILURE,
)

export const GET_SHOWROOM_OPEN_TIMES = 'get showroom open times'
export const getShowroomOpenTimes = fsaPayloadByKeys(GET_SHOWROOM_OPEN_TIMES, [
  'date',
  'locationId',
  'serviceId',
])

export const GET_SHOWROOM_OPEN_TIMES_PENDING = 'get showroom open times pending'
export const getShowroomOpenTimesPending = fsa(GET_SHOWROOM_OPEN_TIMES_PENDING)

export const GET_SHOWROOM_OPEN_TIMES_SUCCESS = 'get showroom open times success'
export const getShowroomOpenTimesSuccess = fsaPayload(GET_SHOWROOM_OPEN_TIMES_SUCCESS)

export const GET_SHOWROOM_OPEN_TIMES_FAILURE = 'get showroom open times failure'
export const getShowroomOpenTimesFailure = fsaError(GET_SHOWROOM_OPEN_TIMES_FAILURE)
